import React from 'react';
import {Fab} from 'native-base';
import {SynchronizationIcon} from '../icons';

interface Props {
  onTap?: () => void;
}

const SynchronizationItem = function (props: Props) {
  const {onTap: handleOnTap} = props;

  const handlePress = () => {
    if (handleOnTap) {
      handleOnTap();
    }
  };

  return (
    <>
      <Fab
        renderInPortal={false}
        shadow={2}
        right={4}
        bottom={175}
        icon={<SynchronizationIcon />}
        onPress={handlePress}
        boxSize="70"
      />
    </>
  );
};

export default SynchronizationItem;
